import * as React from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDownIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

function Accordion({ ...props }: React.ComponentProps<typeof AccordionPrimitive.Root>) {
  return <AccordionPrimitive.Root data-slot="accordion" {...props} />;
}

function AccordionItem({
  className,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Item>) {
  return (
    <AccordionPrimitive.Item
      data-slot="accordion-item"
      className={cn('vtwo:border-b vtwo:last:border-b-0', className)}
      {...props}
    />
  );
}

function AccordionTrigger({
  className,
  children,
  hideDefaultChevron = false,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Trigger> & {
  hideDefaultChevron?: boolean;
}) {
  return (
    <AccordionPrimitive.Header className="vtwo:flex">
      <AccordionPrimitive.Trigger
        data-slot="accordion-trigger"
        className={cn(
          'vtwo:focus-visible:border-ring vtwo:focus-visible:ring-ring/50 vtwo:flex vtwo:flex-1 vtwo:items-start vtwo:justify-between vtwo:gap-4 vtwo:rounded-md vtwo:py-4 vtwo:text-left vtwo:text-sm vtwo:font-medium vtwo:transition-all vtwo:outline-none vtwo:hover:underline vtwo:focus-visible:ring-[3px] vtwo:disabled:pointer-events-none vtwo:disabled:opacity-50 vtwo:[&[data-state=open]>svg]:rotate-180',
          className
        )}
        {...props}
      >
        {children}
        {!hideDefaultChevron && (
          <ChevronDownIcon className="vtwo:text-muted-foreground vtwo:pointer-events-none vtwo:size-4 vtwo:shrink-0 vtwo:translate-y-0.5 vtwo:transition-transform vtwo:duration-200" />
        )}
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
}

function AccordionContent({
  className,
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Content>) {
  return (
    <AccordionPrimitive.Content
      data-slot="accordion-content"
      className="vtwo:data-[state=closed]:animate-accordion-up vtwo:data-[state=open]:animate-accordion-down vtwo:overflow-hidden vtwo:text-sm"
      {...props}
    >
      <div className={cn('vtwo:pt-0 vtwo:pb-4', className)}>{children}</div>
    </AccordionPrimitive.Content>
  );
}

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
